import { Navigation } from 'react-router-dom';

export function disableWhenLoading(navigation: Navigation) {
  return navigation.state === 'loading' || navigation.state === 'submitting';
}
